window.$ = require('jquery');

$(document).ready(function() {
    var fontStylesheets = [
        'https://use.typekit.net/pob1ctq.css'
    ];

    fontStylesheets.forEach(function(stylesheetUrl) {
        $('head').append($('<link rel="stylesheet" type="text/css" />').attr('href', stylesheetUrl));
    });
});
